import React from 'react'
import { NavLink } from 'react-router-dom'
import subnavigation from '../SubNavigation'
import { SubArrow, Icon } from '../NavigationComponents'
import { toggleNav } from 'scripts/components/navigations/helpers/NavigationHelpers'
import { dispatcher } from '../NavigationDispatcher'
import Constants from 'scripts/base/Constants'
import PropTypes from 'prop-types'
import { actions } from 'scripts/store'

function renderChildren(item) {
  return renderDropDown(item, {
    listClasses: 'navbar-dropdown-item',
    aClasses: 'navbar-dropdown-link navbar-link site-logo-link'
  })
}

function renderDropDown(item, props) {
  const listClasses = props.listClasses
  const aClasses = props.aClasses
  return (
    <ListItemSubNav listClasses={listClasses} classes={aClasses} {...item} key={item.name} activeClasses={`active-route`} locale={props.locale} />
  )
}

function ListLink(props) {
  let name

  const onClickCallback = (e) => {
    actions.setSection(props.section)
    props.toggleWithId(e)
  }

  if (props.iconClass) {
    name = <Icon {...props} />
  } else {
    name = props.name
  }

  if (props.image) {
    return (
      <a className={props.classes} href={props.link} onClick={props.toggleWithId}>
        <img src={props.image} className="navbar-link-img" />
      </a>
    )
  } else if (props.link && (props.link === 'javascript:;' || props.link.indexOf('/') > 0)) {
    return (
      <a className={props.classes} href={props.link} onClick={props.toggleWithId}>
        { name } {props.subArrow}
      </a>
    )
  }

  // this is for single page app routing where we use Link component tag instead of the a tag
  if (props.callback) {
    return (
      <a className={`${props.classes} ${props.id}`} href="javascript:;" onClick={() => { props.callback(); props.toggleWithId() }} id={props.id}>
        { name } {props.subArrow}
      </a>
    )
  } else if (props.type === 'text') {
    return (<div className="nav-text">{ name }</div>)
  } else if (props.type === 'separator') {
    return (<div className="separator"></div>)
  } else {
    return (
      <NavLink className={`${props.classes} ${props.id}`}
        to={props.link}
        activeClassName={props.activeClasses}
        exact={true} onClick={e => onClickCallback(e)}> { name } {props.subArrow}
      </NavLink>
    )
  }
}

function ListItem(props) {
  const SubArrowElement = <SubArrow {...props} />

  return (
    <li className={props.listClasses}>
      <ListLink {...props} subArrow={SubArrowElement} />
      <ExtendedDropDown {...props} id={props.dropdown} />
    </li>
  )
}

function ListItemSubNav(props) {
  const List = subnavigation(ListItem)
  return (
    <List {...props} />
  )
}

function ExtendedDropDown(props) {
  if (props.subs) {
    return <ExpandedDropDown {...props} />
  } else {
    return null
  }
}

class ExpandedDropDown extends React.Component {
  constructor(props) {
    super(props)
    this.updateDom = this.updateDom.bind(this)
  }

  updateDom(data) {
    if (data.id === this.props.id) {
      toggleNav({ hidden: true, component: this }, data, this.props)
    }
  }

  componentDidMount() {
    dispatcher.on(Constants.Navigations.TOGGLE_NAV_CLASS, this.updateDom)
  }

  componentWillUnmount() {
    dispatcher.off(Constants.Navigations.TOGGLE_NAV_CLASS, this.updateDom)
  }

  render() {
    return (
      <div className={`navbar-expand hidden`}>
        <div className="container">
          <div className="row">
            <div className="col small-12 med-3 navbar-border-right">
              <div className="navbar-expand-item">
                <ul>
                  {this.props.subs.updates.map((item) => {
                    return renderDropDown(item, { listClasses: 'navbar-expand-list-item', aClasses: 'navbar-expand-link-item' })
                  })}
                </ul>
              </div>
            </div>
            <div className="col small-12 med-6 navbar-border-right">
              <div className="navbar-expand-item columnize-links-med">
                <ul>
                  {this.props.subs.main.map((item) => {
                    return renderDropDown(item, { listClasses: 'navbar-expand-list-item', aClasses: 'navbar-expand-link-item' })
                  })}
                </ul>
              </div>
            </div>
            <div className="col small-12 med-3">
              <div className="navbar-expand-item">
                <ul>
                  {this.props.subs.other.map((item) => {
                    return renderDropDown(item, { listClasses: 'navbar-expand-list-item', aClasses: 'navbar-expand-link-item' })
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ListItemSubNav.propTypes = {
  classes: PropTypes.string,
  listClasses: PropTypes.string,
  contextual: PropTypes.string,
  id: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  subs: PropTypes.object,
  dropdown: PropTypes.string
}

ListItem.propTypes = {
  classes: PropTypes.string,
  listClasses: PropTypes.string,
  contextual: PropTypes.string,
  id: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  subs: PropTypes.object,
  dropdown: PropTypes.string
}

ListLink.propTypes = {
  classes: PropTypes.string,
  listClasses: PropTypes.string,
  contextual: PropTypes.string,
  id: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  subs: PropTypes.object,
  dropdown: PropTypes.string,
  subArrow: PropTypes.element,
  type: PropTypes.string
}

ExpandedDropDown.propTypes = {
  classes: PropTypes.string,
  listClasses: PropTypes.string,
  contextual: PropTypes.string,
  id: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  subs: PropTypes.object,
  dropdown: PropTypes.string
}

module.exports = {
  renderDropDown,
  ExpandedDropDown,
  renderChildren
}



// WEBPACK FOOTER //
// ./assets/js/components/navigations/lists/ListNav.jsx